import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'

import { ReactComponent as CloseIcon } from '../../../assets/images/icons/i-cross-16-16.svg'
import clsx from 'clsx'

class Modal extends Component {
  state = {
    parent: null,
  }

  componentDidMount() {
    const parent = document.querySelector('.work-space')
    this.setState({ parent })
  }

  render() {
    const { parent } = this.state
    const {
      isOpen,
      onCloseModal,
      children,
      prominent: isProminent,
      closeId,
      modalId
    } = this.props

    return (
      isOpen &&
      createPortal(
        <div>
          <div className="modal-overlay" onClick={onCloseModal} />
          <div className="modal-wrapper">
            <div className={clsx('modal', {'modal_prominent': isProminent})} id={modalId}>
              <CloseIcon
                id={closeId}
                className="modal__close-icon"
                onClick={onCloseModal}
              />
              {children}
            </div>
          </div>
        </div>,
        parent
      )
    )
  }
}

Modal.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  prominent: PropTypes.bool,
  closeId: PropTypes.string,
  modalId: PropTypes.string,
  children: PropTypes.any,
}

export default Modal
